import { createStore as customCreateStore} from './template.store.js'

export const createStore = () => {
  return customCreateStore()
}